var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Checkmark as CheckmarkIcon, Minus } from '../icon';
import { checkmarkStyle } from './styles';
function Checkmark(_a) {
    var inverted = _a.inverted, checked = _a.checked, isIndeterminate = _a.isIndeterminate, error = _a.error, isFocusVisible = _a.isFocusVisible;
    function renderIcon() {
        if (isIndeterminate) {
            return _jsx(Minus, { size: "small" });
        }
        else if (checked) {
            return _jsx(CheckmarkIcon, { size: "small" });
        }
        return null;
    }
    return (_jsx("div", __assign({ css: checkmarkStyle({
            inverted: inverted,
            checked: checked,
            isIndeterminate: isIndeterminate,
            isFocusVisible: isFocusVisible,
            hasError: error,
        }) }, { children: renderIcon() })));
}
export default Checkmark;
